"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SDK_VERSION = void 0;

var apiCall = function apiCall(name) {
  var _window;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return (_window = window).__ls.apply(_window, [name].concat(args));
};

var api = {
  init: function init(trackID, options) {
    return apiCall("init", trackID, options);
  },
  getSessionURL: function getSessionURL(callback) {
    return apiCall("getSessionURL", callback);
  },
  identify: function identify(data) {
    return apiCall("identify", data);
  },
  invalidateSession: function invalidateSession() {
    return apiCall("invalidateSession");
  },
  newPageView: function newPageView(options) {
    return apiCall("newPageView", options);
  },
  setOptions: function setOptions(options) {
    return apiCall("setOptions", options);
  },
  setCustomParams: function setCustomParams(data) {
    return apiCall("setCustomParams", data);
  },
  off: function off() {
    return apiCall("off");
  },
  optOut: function optOut() {
    return apiCall("optOut", true);
  },
  debug: function debug() {
    return apiCall("debug", true);
  },
  track: function track(eventName, properties) {
    return apiCall("track", eventName, properties);
  },
  log: function log(logLevel) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      rest[_key2 - 1] = arguments[_key2];
    }

    return apiCall("log", logLevel, rest);
  }
};
exports.SDK_VERSION = "1.1.0";
exports.default = api;